/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/signup.css";
import { Button, Segment, Form, Header, Label, Icon, Image } from "semantic-ui-react";
import { Input, FreeForm, FormRow, Dropdown } from "kx-common-components";
import { Redirect, Link } from "react-router-dom";
import API from "../utility/API";
import { get } from "lodash";
import Logo from "../media/newlogo2.png";

const userType = {
  CUSTOMER_USER: "An Importer",
  FREIGHT_FORWARDER: "A Freight Forwarder",
  CHANNEL_USER: "A Channel"
};

class SignupType extends Component {
  constructor() {
    super();
    this.state = {
      companyName: "",
      email: "",
      contactName: "",
      error: false,
      nextPath: "/"
    };
  }

  handleUpdate(key, e) {
    this.setState({ [key]: e });
    if (key === "typeOfUser") {
      this.setState({
        nextPath: e === "CUSTOMER_USER" ? "/signup/importer" : e === "FREIGHT_FORWARDER" ? "/signup/ff" : e === "CHANNEL_USER" ? "/signup/channel" : null
      });
    }
  }

  render() {
    const { companyName, email, contactName, toNextPage, typeOfUser, nextPath } = this.state;

    if (toNextPage === true) {
      return <Redirect to="/thanks" />;
    }

    return (
      <Segment padded="very" className="signup-container">
        <p className="login-header">I am ... </p>

        <div className="login-form">
          <Dropdown value={userType[typeOfUser]}handleSelect={(e) => this.handleUpdate("typeOfUser", e)}  list={userType}  label={"TYPE OF USER"} rounded topLabel />
          <Link to={nextPath}>
            <Button className="login-button">NEXT</Button>
          </Link>
        </div>
      </Segment>
    );
  }
}

export default SignupType;
